import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { sexOptions } from 'constants/enums/physicalOptions';
import { isPVQForm } from 'helpers/form';
import { FinancialCreditModel } from './types';
import financialCreditItemValidator from './validators/item';

const financialCreditValidator: ValidateJSModel<FinancialCreditModel> = {
  HasCreditCounseling: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.HasCreditCounselingNotApplicable?.applicable === false) {
      return {};
    }

    return {
      hasValue: { validator: hasYesOrNo }
    };
  },

  HasCreditCounselingNotApplicable: {},

  List: (value, attributes) => {
    if (attributes?.HasCreditCounseling?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialCreditItemValidator },
      };
    }

    return {};
  },
};

export default financialCreditValidator;
